<script setup>
import SectionTop from "@/components/additional/SectionTop.vue";
import Button from "@/components/base/Button.vue";
import AccordionItem from "@/components/additional/AccordionItem.vue";
import { handleAnchorClick } from "@/utils/scrollToAnchor";

const accordionItems = [
  {
    title: "Casino & Game Content",
    items: [
      {
        img: "acc1_1.png",
        text: "Known for innovative slot design and daily jackpots"
      },
      {
        img: "acc1_2.png",
        text: "Offers high-performance HTML5 slots and table games"
      },
      {
        img: "acc1_3.png",
        text: "Focused on diverse, mobile-first casino content"
      },
      {
        img: "acc1_4.png",
        text: "Specializes in premium live roulette streaming"
      },
    ]
  },
  {
    title: "Sports Data & Betting Infrastructure",
    items: [
      {
        img: "acc2_1.png",
        text: "Comprehensive sportsbook infrastructure "
      },
      {
        img: "acc2_2.png",
        text: "Modular sportsbook solutions for regulated markets"
      },
      {
        img: "acc2_3.png",
        text: "Automated pricing and risk management"
      },
      {
        img: "acc2_4.png",
        text: "Real-time odds aggregation and monitoring"
      },
    ]
  }
]
</script>

<template>
  <section class="partners relative" id="partners">
    <div class="partners__top flex justify-between">
      <SectionTop>Partners</SectionTop>
      <div class="flex flex-col">
        <p class="text-ms" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">Galazia collaborates with trusted technology vendors, platform providers, and content developers to ensure a secure, engaging, and scalable gaming environment.</p>
        <Button @click="handleAnchorClick('#contacts')">Let’s start</Button>
      </div>
    </div>
    <div class="partners__acc flex flex-col">
      <AccordionItem
          v-for="(acc, index) in accordionItems"
          :key="index"
          :title="acc.title"
          :cards="acc.items"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.partners {
  padding: 8.333vw 8.333vw 5.556vw;
  z-index: 2;
  &__top {
    & > div:last-child {
      width: 50%;
      gap: 2.778vw;
      max-width: clamp(423px, 29.375vw, 2500px);
      p {
        color: rgba(255, 255, 255, 0.70);
      }
    }
  }
  &__acc {
    gap: clamp(26px, 2.431vw, 180px);
    margin-top: clamp(60px, 4.167vw, 300px);
  }
}
@media (max-width: 768px) {
  .partners {
    padding: 50px 24px;
    &__top {
      flex-direction: column;
      gap: 40px;
      & > div:last-child {
        width: 100%;
        gap: 40px;
      }
    }
  }
}
</style>